module.exports = __webpack_public_path__ + "static/media/referral-es.7494e81d.png";